import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import MenuVertical from "../../layouts/MenuVertical";
import { Button, Form, Icon, List, Loader, Message, Pagination } from "semantic-ui-react";
import { findByIdAndBloquearVotacao } from "../../../actions/unidade";
import Unidade from "./Unidade";
import CondominioVencido from "../admin/CondominioVencido";
import moment from 'moment';
import api from '../../../api';
import ModalEnviarEmail from "./ModalEnviarEmail";
import ModalImportarAlmah, { ResumoAlmah } from "./ModalImportarAlmah";
import { saveAs } from "file-saver";
import { base64toBlob } from "../../../utils/fileSaverHelper";
import CardRelatorioUnidade from "./CardRelatorioUnidade";
import Erro from "../../layouts/mensagens/Erro";
import { getDataAtual } from "../../../utils/formatador";
import * as FormValidator from "../../../utils/formValidator";
import { isDataValida } from "../../../utils/formValidator";
import CampoData from "../../layouts/CampoData";

const Unidades = ({ match: { params } }) => {
  const dispatch = useDispatch();

  const usuario = useSelector(state => state.user.user);

  const [condominio, setCondominio] = useState({});
  const [unidades, setUnidades] = useState([]);
  const [habilitado, setHabilitado] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [errorsLeituraEmail, setErrorsLeituraEmail] = useState({});
  const [registrosFiltrados, setRegistrosFiltrados] = useState([]);
  const [modalBatchActionOpen, setModalBatchActionOpen] = useState(false);
  const [messageVisible, setMessageVisible] = useState(false);
  const [sincronizandoUnidades, setSincronizandoUnidades] = useState(false);
  const [isUnidadesVazia, setIsUnidadesVazia ] = useState(true);
  const [busca, setBusca] = useState('');
  const [filtro, setFiltro] = useState('todas');
  const [relatoriosAbertos, setRelatoriosAbertos] = useState(false);
  const [modalAlmahAberto, setModalAlmahAberto] = useState(false);
  const [resultadoSync, setResultadoSync] = useState(null);
  const [tipoSincronizando, setTipoSincronizando] = useState(null);
  const [pagination, setPagination] = useState({
    dados: [],
    paginaAtual: 1,
    totalDePaginas: 0,
    registrosPorPagina: 10,
  });
  const [formulario, setFormulario] = useState({
    dataInicioFiltro: getDataAtual(1),
    dataFimFiltro: getDataAtual(0),
  });
  const [formularioLeituraEmail, setFormularioLeituraEmail] = useState({
    dataInicioFiltro: getDataAtual(1),
    dataFimFiltro: getDataAtual(0),
  });

  const interval = useRef();

  useEffect(
    () => {
      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(
    () => {
      if (sincronizandoUnidades) {
        interval.current = setInterval(checkSyncStatus, 5000);
      } else {
        if (!!interval.current) {
          clearInterval(interval.current);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sincronizandoUnidades]
  );

  useEffect(
    () => {
      if (condominio._id) {
        checkSyncStatus();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [condominio]
  );

  useEffect(() => {
    setIsUnidadesVazia(!unidades || unidades.length === 0);
  }, [unidades]);

  const load = async () => {
    setLoading(true);
    try {
      const cond = await api.condominio.findSimpleById(params.id);
      setCondominio(cond);

      const isHabilitado = await api.unidade.validarQuantidade(cond._id).then(it => it.habilitado);
      setHabilitado(isHabilitado);

      const unidadesRes = await api.unidade.find(cond._id).then(it => it.unidades);
      setUnidades(unidadesRes);

      const filtradas = filtrar(unidadesRes, busca, filtro);
      setRegistrosFiltrados(filtradas);
      updatePagination(filtradas, true);
    } catch (e) {
      setErrors((e.data && e.data.errors) || {});
    }
    setLoading(false);
  };

  const isCondominioValido = () =>
    condominio.dataVencimento && moment(condominio.dataVencimento) >= moment();

  const atingiuLimite = () =>
    condominio.totalUnidades === condominio.countUnidades;

  const botaoBloquearClickHandler = async (e, data) => {
    setLoading(true);
    dispatch(findByIdAndBloquearVotacao(data.unidade._id));
    load();
  };

  const enviarEmailClickHandle = async(e) => {
    let idsUnidades = await unidades.map(it => it._id);
    setMessageVisible(true);
    setTimeout(() => {
      setMessageVisible(false);
    }, 3000);
    await api.unidade.enviarEmailUnidades({ condominio: condominio._id, unidadesSelecionadas: idsUnidades});
  };

  const modalBatchActionToggle = () => {
    setModalBatchActionOpen(!modalBatchActionOpen);
  };

  const isDemo = () => usuario.tipo === 'demo';

  const isCadastrarDesabilitado = () =>
    !isDemo() && (!isCondominioValido() || atingiuLimite());

  const containsInField = value => {
    const val = value.toLowerCase();
    const has = field => (field || '').toLowerCase().indexOf(val) !== -1;
    return it => has(it.bloco) || has(it.numero) || has(it.descricao) || (!!it.responsavel && has(it.responsavel.nome));
  };

  const filtrar = (lista, termo, status) =>
    lista
      .filter(containsInField(termo))
      .filter(it => status === 'todas' || (status === 'bloqueadas' ? !!it.bloqueadoVotacao : !it.bloqueadoVotacao));

  const aplicarFiltros = (termo, status) => {
    const dados = filtrar(unidades, termo, status);
    setRegistrosFiltrados(dados);
    updatePagination(dados);
  };

  const onChangeSearch = e => {
    setBusca(e.target.value);
    aplicarFiltros(e.target.value, filtro);
  };

  const onChangeFiltro = status => {
    setFiltro(status);
    aplicarFiltros(busca, status);
  };

  const totalBloqueadas = unidades.filter(it => !!it.bloqueadoVotacao).length;

  const updatePagination = (dados, keepPage) =>
    setPagination(p => ({
      ...p,
      dados: Array.from(
        Array(p.registrosPorPagina),
        (_, i) => {
          let idx = keepPage ? i + ((p.paginaAtual - 1) * p.registrosPorPagina) : i;
          return dados[idx];
        }
      ).filter(it => it !== undefined),
      paginaAtual: keepPage ? p.paginaAtual : 1,
      totalDePaginas: Math.ceil(dados.length / p.registrosPorPagina),
    }));

  const changePage = (_, e) => {
    window.scrollTo(0, 0);
    setPagination(p => ({
      ...p,
      paginaAtual: e.activePage,
      dados: Array.from(
        Array(p.registrosPorPagina),
        (_, i) => registrosFiltrados[i + ((e.activePage - 1) * p.registrosPorPagina)])
          .filter(it => it !== undefined),
    }));
  };

  const syncUnidades = async tipo => {
    setTipoSincronizando(tipo);
    setSincronizandoUnidades(true);
    await api.unidade.sincronizar(condominio._id, tipo);
  };

  const temIntegracao = tipo => (usuario.integracoes || []).some(it => it.tipo === tipo);

  const checkSyncStatus = async () => {
    const status = await api.unidade.checkSincronizacao(condominio._id);
    if (status.finalizado) {
      if (sincronizandoUnidades) {
        setSincronizandoUnidades(false);
        if (status.resultado && status.resultado.almah) setResultadoSync(status.resultado.almah);
        load();
      }
    } else {
      if (!sincronizandoUnidades) {
        setSincronizandoUnidades(true);
      }
    }
  };

  const gerarRelatorioUnidades = async () => {
    const erros = validateRelatorioDeAcessos();
    setErrors(erros);

    if (Object.keys(erros).length === 0) {
      const response = await api.unidade.relatorioUnidades(condominio._id, {
        dataInicial: formulario.dataInicioFiltro,
        dataFinal: formulario.dataFimFiltro
      });

      saveAs(await base64toBlob(response, 'application/pdf'), 'relatorio-acessos-unidades.pdf');
    }
  };

  const validateRelatorioDeAcessos = () => {
    const erros = {};

    if (!isDataValida(formulario.dataInicioFiltro)) {
      erros.dataInicioFiltro = 'Data Inicial inválida.'
    }

    if (!isDataValida(formulario.dataFimFiltro)) {
      erros.dataFimFiltro = 'Data Final inválida.'
    }

    if (FormValidator.isVazio(formulario.dataInicioFiltro)) {
      erros.dataInicioFiltro = 'Data Inicial é obrigatória.';
    }

    if (FormValidator.isVazio(formulario.dataFimFiltro)) {
      erros.dataFimFiltro = 'Data Final é obrigatória.';
    }

    if (FormValidator.isDataMenor(formulario.dataFimFiltro, formulario.dataInicioFiltro)) {
      erros.dataFimFiltro = 'Data Final não pode ser inferior a Data Inicial.';
    }

    if (Object.keys(erros).length === 0) {
      if (FormValidator.isDiferencaMesesMaiorQue(formulario.dataInicioFiltro, formulario.dataFimFiltro, 3)) {
        erros.dataFimFiltro = 'O período entre a data inicial e final não pode ser maior que 3 meses.';
      }
    }

    return erros;
  };

  const validateRelatorioDeLeituraEmail = () => {
    const erros = {};

    if (!isDataValida(formularioLeituraEmail.dataInicioFiltro)) {
      erros.dataInicioFiltro = 'Data Inicial inválida.'
    }

    if (!isDataValida(formularioLeituraEmail.dataFimFiltro)) {
      erros.dataFimFiltro = 'Data Final inválida.'
    }

    if (FormValidator.isVazio(formularioLeituraEmail.dataInicioFiltro)) {
      erros.dataInicioFiltro = 'Data Inicial é obrigatória.';
    }

    if (FormValidator.isVazio(formularioLeituraEmail.dataFimFiltro)) {
      erros.dataFimFiltro = 'Data Final é obrigatória.';
    }

    if (FormValidator.isDataMenor(formularioLeituraEmail.dataFimFiltro, formularioLeituraEmail.dataInicioFiltro)) {
      erros.dataFimFiltro = 'Data Final não pode ser inferior a Data Inicial.';
    }

    if (Object.keys(erros).length === 0) {
      if (FormValidator.isDiferencaMesesMaiorQue(formularioLeituraEmail.dataInicioFiltro, formularioLeituraEmail.dataFimFiltro, 3)) {
        erros.dataFimFiltro = 'O período entre a data inicial e final não pode ser maior que 3 meses.';
      }
    }

    return erros;
  };

  const gerarRelatorioLeituraEmail = async () => {
    const erros = validateRelatorioDeLeituraEmail();
    setErrorsLeituraEmail(erros);

    if (Object.keys(erros).length === 0) {
      const response = await api.unidade.relatorioLeituraEmail(condominio._id, {
        dataInicial: formularioLeituraEmail.dataInicioFiltro,
        dataFinal: formularioLeituraEmail.dataFimFiltro
      });
      saveAs(await base64toBlob(response, 'application/pdf'), 'relatorio-leitura-email.pdf');
    }
  };

  const gerarRelatorioListagemUnidades = async () => {
    const response = await api.unidade.relatorioListagemUnidades(condominio._id);
    saveAs(await base64toBlob(response, 'application/pdf'), 'relatorio-listagem-unidades.pdf');
  };

  const getContent = () =>
    pagination.dados.length > 0 ? (
      <>
        <List verticalAlign="middle">
          {pagination.dados.map((unidade, i) => (
            <Unidade unidade={unidade} key={unidade._id} bloquearHandle={botaoBloquearClickHandler} />
          ))}
        </List>
        {pagination.totalDePaginas > 1 && (
          <div style={{ textAlign: 'center', marginTop: 30 }}>
            <Pagination activePage={pagination.paginaAtual} totalPages={pagination.totalDePaginas} onPageChange={changePage} />
          </div>
        )}
      </>
    ) : (
      <div className="empty-illustration-1">
        <img
          src="/images/illustrations/lupa-casa.svg"
          alt="Nenhuma Unidade Votante Encontrada"
        />
      </div>
    );

  const onChange = ({ target: { name, value } }) => changeFormulario(name, value);
  const onChangeFormularioLeituraEmail = ({ target: { name, value } }) => changeFormularioLeituraEmail(name, value);
  const changeFormulario = (name, value) => setFormulario(p => ({ ...p, [name]: value }));
  const changeFormularioLeituraEmail = (name, value) => setFormularioLeituraEmail(p => ({ ...p, [name]: value }));

  const isAtivo = () => condominio.dataVencimento && moment(condominio.dataVencimento) >= moment();

  return (
    <div>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <header className="va-un-cabecalho">
          <div>
            <h1>Unidades votantes</h1>
            <p>Gerencie quem pode votar, edite os dados dos responsáveis e envie o token de acesso.</p>
          </div>
        </header>

        {!loading && (
          <div className="va-un-barra-acoes">
            <CondominioVencido condominio={condominio}>
              {(isDemo() && !habilitado) || (isCondominioValido() && atingiuLimite()) ? (
                <div className="va-un-limite">
                  <Icon name="info circle" /> Todas as {isDemo() ? condominio.countUnidades : condominio.totalUnidades} unidades votantes já foram criadas.
                  <Link to={`/condominios/${condominio._id}/comprar`}> Adicionar mais</Link>
                </div>
              ) : (
                <Button
                  className="btn-ui-1"
                  as={Link}
                  to={`/condominios/${condominio._id}/unidades/cadastrar`}
                  size="large"
                  disabled={isCadastrarDesabilitado()}
                >
                  <Icon name="plus" /> Cadastrar Unidade Votante
                </Button>
              )}
              <Button
                color="green"
                size="large"
                onClick={modalBatchActionToggle}
                disabled={isUnidadesVazia}
              >
                <Icon name="mail outline" /> Enviar token para todas
              </Button>
              {[
                { chave: 'sincSuperlogica', tipo: 'SUPERLOGICA', nome: 'Superlógica', icone: 'sync', acao: () => syncUnidades('SUPERLOGICA') },
                { chave: 'sincAlmah', tipo: 'ALMAH', nome: 'Almah', icone: 'sync', acao: () => syncUnidades('ALMAH') },
                { chave: 'importAlmah', tipo: 'ALMAH', nome: 'Almah', icone: 'cloud download', acao: () => setModalAlmahAberto(true), importar: true },
              ].map(({ chave, tipo, nome, icone, acao, importar }) => {
                const configurada = temIntegracao(tipo);
                const emAndamento = sincronizandoUnidades && !importar && tipoSincronizando === tipo;
                const botao = (
                  <Button
                    size="large"
                    className={importar ? 'btn-ui-1 btn-ui-1-basic' : 'btn-sincronizar'}
                    onClick={acao}
                    disabled={sincronizandoUnidades && !importar}
                  >
                    <Icon name={icone} loading={emAndamento} />
                    {importar ? `Importar do ${nome}` : emAndamento ? `Sincronizando ${nome}...` : `Sincronizar ${nome}`}
                  </Button>
                );
                // sem a integração configurada o botão nem aparece
                return configurada ? <React.Fragment key={chave}>{botao}</React.Fragment> : null;
              })}
            </CondominioVencido>
          </div>
        )}

        {resultadoSync && (
          <div className="va-almah-painel">
            <button type="button" className="va-almah-fechar" onClick={() => setResultadoSync(null)} aria-label="Fechar resumo"><Icon name="close" /></button>
            <ResumoAlmah resumo={resultadoSync} />
          </div>
        )}
        <ModalImportarAlmah
          aberto={modalAlmahAberto}
          onFechar={() => setModalAlmahAberto(false)}
          condominioId={condominio._id}
          onConcluido={load}
        />

        <div className="va-un-filtros">
          <div className="va-un-busca">
            <Icon name="search" />
            <input
              type="search"
              placeholder="Buscar por bloco, número, descrição ou proprietário"
              value={busca}
              onChange={onChangeSearch}
              aria-label="Buscar unidade votante"
            />
          </div>
          <div className="va-un-abas" role="tablist">
            {[
              ['todas', 'Todas', unidades.length],
              ['habilitadas', 'Habilitadas', unidades.length - totalBloqueadas],
              ['bloqueadas', 'Bloqueadas', totalBloqueadas],
            ].map(([chave, rotulo, qtd]) => (
              <button
                type="button"
                role="tab"
                aria-selected={filtro === chave}
                key={chave}
                className={`${filtro === chave ? 'ativo' : ''} ${chave === 'bloqueadas' && qtd > 0 ? 'alerta' : ''}`}
                onClick={() => onChangeFiltro(chave)}
              >
                {rotulo} <span>{qtd}</span>
              </button>
            ))}
          </div>
        </div>

        {loading || !(isDemo() || isAtivo()) ? null : (
          <section className="va-un-relatorios">
            <button type="button" className="va-un-relatorios-titulo" onClick={() => setRelatoriosAbertos(v => !v)} aria-expanded={relatoriosAbertos}>
              <span><Icon name="file pdf outline" /> Relatórios em PDF</span>
              <span className="va-un-relatorios-dica">Acessos, leitura de e-mail e listagem de unidades</span>
              <Icon name={relatoriosAbertos ? 'chevron up' : 'chevron down'} />
            </button>
            {relatoriosAbertos && (
              <div className="va-rel-grid" style={{ marginTop: 10 }}>
                <CardRelatorioUnidade
                    icon="mobile alternate"
                    label="Relatório de Acessos"
                    descricao="Unidades que já entraram no aplicativo dentro do período informado."
                    onClick={gerarRelatorioUnidades}
                    disabled={isUnidadesVazia}
                >
                  <Form>
                    <Form.Group widths={2}>
                      <Form.Field error={!!errors.dataInicioFiltro}>
                        <label>Data inicial</label>
                        <CampoData id="dataInicioFiltro" name="dataInicioFiltro" onChange={onChange} value={formulario.dataInicioFiltro} />
                        <Erro text={errors.dataInicioFiltro}/>
                      </Form.Field>
                      <Form.Field error={!!errors.dataFimFiltro}>
                        <label>Data final</label>
                        <CampoData id="dataFimFiltro" name="dataFimFiltro" onChange={onChange} value={formulario.dataFimFiltro} />
                        <Erro text={errors.dataFimFiltro}/>
                      </Form.Field>
                    </Form.Group>
                  </Form>
                </CardRelatorioUnidade>
                <CardRelatorioUnidade
                    icon="mail outline"
                    label="Relatório de Leitura de E-mail"
                    descricao="Quem recebeu e quem abriu o e-mail com o token de acesso."
                    onClick={gerarRelatorioLeituraEmail}
                    disabled={isUnidadesVazia}
                >
                  <Form>
                    <Form.Group widths={2}>
                      <Form.Field error={!!errorsLeituraEmail.dataInicioFiltro}>
                        <label>Data inicial</label>
                        <CampoData id="dataInicioFiltro" name="dataInicioFiltro" onChange={onChangeFormularioLeituraEmail} value={formularioLeituraEmail.dataInicioFiltro} />
                        <Erro text={errorsLeituraEmail.dataInicioFiltro}/>
                      </Form.Field>
                      <Form.Field error={!!errorsLeituraEmail.dataFimFiltro}>
                        <label>Data final</label>
                        <CampoData id="dataFimFiltro" name="dataFimFiltro" onChange={onChangeFormularioLeituraEmail} value={formularioLeituraEmail.dataFimFiltro} />
                        <Erro text={errorsLeituraEmail.dataFimFiltro}/>
                      </Form.Field>
                    </Form.Group>
                  </Form>
                </CardRelatorioUnidade>
                <CardRelatorioUnidade
                    icon="list alternate outline"
                    label="Listagem de Unidades"
                    descricao="Todas as unidades com responsável, documento, e-mail e situação de votação."
                    onClick={gerarRelatorioListagemUnidades}
                    disabled={isUnidadesVazia}
                />
              </div>
            )}
          </section>
        )}
        <ModalEnviarEmail
          modalOpen={modalBatchActionOpen}
          btnConfirmAction={enviarEmailClickHandle}
          toggleFunction={modalBatchActionToggle}
          message="Deseja realmente enviar o token para todas as unidades votantes?"
        />
        {messageVisible && (
          <Message positive>
            <Message.Header>Tudo ok!</Message.Header>
            <p>
              Os e-mails já estão a caminho.
            </p>
          </Message>
        )}
        {loading ? <Loader active inline="centered" style={{ marginTop: "50px" }} /> : getContent()}
      </div>
    </div>
  );
}

export default Unidades;
